import { ICON_ATTR } from '../functions/select';
import { querySelectorAll, querySelector } from '../functions/querySelectors';
import { SELECT_CLASS } from '../scripts/typo';

const FONT_ATTR = 'product-filter-font';
const FONT_WRAPPER_CLASS = 'js-font-wrapper';
const FONT_TEXT_CLASS = 'js-font-text-input';

let loadedFonts = [];

let loadFont = function(fontName, fontSrc) {
  let style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = `
    @font-face {
      font-family: '${fontName}';
      font-weight: 400;
      font-style: normal;
      src: url("${fontSrc}") format("truetype");
    }
  `;

  document.body.appendChild(style);
  loadedFonts.push(fontName);
};

let fontSelectChange = function(event) {
  let wrapper = this.closest(`.${FONT_WRAPPER_CLASS}`);
  let input = querySelector(`.${FONT_TEXT_CLASS}`, wrapper);
  let fontName = this.value;
  let fontSrc = this.options[this.options.selectedIndex].getAttribute('data-font');

  if (fontSrc && input) {
    if (loadedFonts.indexOf(fontName) === -1) {
      loadFont(fontName, fontSrc);
    }

    input.style.fontFamily = `'${fontName}'`;
  }
};

export function setFontChecker() {
  let fontSelects = querySelectorAll(`.${SELECT_CLASS}[${ICON_ATTR}="${FONT_ATTR}"]`);

  fontSelects.forEach((fontSelect) => {
    fontSelect.addEventListener('change', fontSelectChange);
  });
};
